import React, { useState } from "react";
import Lottie from "react-lottie";
import myAnimation from "../../../animations/changePassword.json";
import Input from "../../common/FormInputs";
import { useSelector } from "react-redux";

const UpdatePassword = ({
  values,
  errors,
  touched,
  handleBlur,
  handleChange,
  setFieldValue,
}) => {
  const role = useSelector(
    (state) => state?.authReducer?.tokenData?.user?.role
  );

  const [showPasswords, setShowPasswords] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const togglePassword = (field) => {
    setShowPasswords((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: myAnimation,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid meet",
    },
  };

  return (
    <div className="w-full flex flex-col-reverse md:flex-row justify-between items-center">
      <div className="w-full md:w-[50%] flex flex-col justify-center items-center">
        <Input
          type={showPasswords.currentPassword ? "text" : "password"}
          label=""
          placeholder={"Current Password"}
          width="100%"
          radius="5px"
          InputDivClass="w-full mt-8"
          name="currentPassword"
          value={values?.currentPassword}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.currentPassword}
          touched={touched.currentPassword}
          showPassword={showPasswords.currentPassword}
          togglePassword={() => togglePassword("currentPassword")}
        />
        <Input
          type={showPasswords.newPassword ? "text" : "password"}
          label=""
          placeholder="New Password"
          width="100%"
          radius="5px"
          InputDivClass="w-full mt-8"
          name="newPassword"
          value={values?.newPassword}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.newPassword}
          touched={touched.newPassword}
          showPassword={showPasswords.newPassword}
          togglePassword={() => togglePassword("newPassword")}
        />
        <Input
          type={showPasswords.confirmPassword ? "text" : "password"}
          label=""
          placeholder="Confirm New Password"
          width="100%"
          radius="5px"
          InputDivClass="w-full mt-8"
          name="confirmPassword"
          value={values?.confirmPassword}
          handleChange={handleChange}
          handleBlur={handleBlur}
          error={errors.confirmPassword}
          touched={touched.confirmPassword}
          showPassword={showPasswords.confirmPassword}
          togglePassword={() => togglePassword("confirmPassword")}
        />
      </div>
      <div className="w-full md:w-[40%] h-[250px] text-center">
        <Lottie
          options={defaultOptions}
          height="100%"
          width="100%"
          isResponsive={true}
        />
      </div>
    </div>
  );
};

export default UpdatePassword;
